// extracted by mini-css-extract-plugin
export default {"title":"password_title__BVXAc","input":"password_input__-1wo9","button":"password_button__kpPRp","form":"password_form__8x1QD","mobile":"password_mobile__sIVKr"};